import {
	combineReducers
} from 'redux-immutable';
import customerListReducer from './customerListReducer';
import customerReducer from './customerReducer';
import orderListReducer from './orderListReducer';
import orderReducer from './orderReducer';
import orderDetailListReducer from './orderDetailListReducer';
import orderDetailBespokeListReducer from './orderDetailBespokeListReducer';
import commonReducer from './commonReducer';
import washLabelReducer from './washLabelReducer';
import otherLabelReducer from './otherLabelReducer';
import chipUploadReducer from './chipUploadReducer';
import bagLabelReducer from './bagLabelReducer';
import fittingReducer from './fittingReducer';
import fitting1Reducer from './fitting1Reducer';
import fittingListReducer from './fittingListReducer';
import fittingBatchListReducer from './fittingBatchListReducer';
import labelReducer from './labelReducer';
import packingReducer from './packingReducer';
import packingItemListReducer from './packingItemListReducer';
import gearSpecListReducer from './gearSpecListReducer';
import gearSpecReducer from './gearSpecReducer';
import gearModelListReducer from './gearModelListReducer';
import gearModelReducer from './gearModelReducer';
import authReducer from './authReducer';
import specialNoteListReducer from './specialNoteListReducer';
import searchReducer from './searchReducer';
import searchEpcListReducer from './searchEpcListReducer';
import menuReducer from './menuReducer';
import addMaintenanceCaseReducer from './addMaintenanceCaseReducer';
import maintenanceOrderReducer from './maintenanceOrderReducer';
import maintenanceOrderListReducer from './maintenanceOrderListReducer';
import maintenanceOrderDetailListReducer from './maintenanceOrderDetailListReducer';
import maintenanceCasesReducer from './maintenanceCasesReducer';
import maintenanceCardsReducer from './maintenanceCardsReducer';
import checkCardReducer from './checkCardReducer';
import manageCheckItemReducer from './manageCheckItemReducer';
import maintenanceRefineReducer from './maintenanceRefineReducer';
import alertReducer from './alertReducer';
import maintenanceFixingReducer from './maintenanceFixingReducer';
import maintenanceAuditingReducer from './maintenanceAuditingReducer';
import downloadMPhotosReducer from './downloadMPhotosReducer';
import downloadItemsReducer from './downloadItemsReducer';
import photoListReducer from './photoListReducer';
import maintenanceSearchReducer from './maintenanceSearchReducer';
import searchMRecordListReducer from './searchMRecordListReducer';

const rootReducer = combineReducers({
	customerListReducer,
	customerReducer,
	orderListReducer,
	orderReducer,
	orderDetailListReducer,
	orderDetailBespokeListReducer,
	commonReducer,
	washLabelReducer,
	otherLabelReducer,
	chipUploadReducer,
	bagLabelReducer,
	fittingReducer,
	fitting1Reducer,
	fittingListReducer,
	fittingBatchListReducer,
	labelReducer,
	packingReducer,
	packingItemListReducer,
	gearSpecListReducer,
	gearSpecReducer,
	gearModelListReducer,
	gearModelReducer,
	authReducer,
	specialNoteListReducer,
	searchReducer,
	searchEpcListReducer,
	menuReducer,
	addMaintenanceCaseReducer,
	maintenanceOrderReducer,
	maintenanceOrderListReducer,
	maintenanceOrderDetailListReducer,
	maintenanceCasesReducer,
	maintenanceCardsReducer,
	checkCardReducer,
	manageCheckItemReducer,
	maintenanceRefineReducer,
	alertReducer,
	maintenanceFixingReducer,
	maintenanceAuditingReducer,
	downloadMPhotosReducer,
	downloadItemsReducer,
	photoListReducer,
	maintenanceSearchReducer,
	searchMRecordListReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js